import { graphql } from "react-relay";

export const chromePersonalCalendarFragments = {
  user: graphql`
    fragment ChromePersonalCalendar_user on User {
      dataSources(first: 1000000) {
        edges {
          node {
            id
            state
            type
            name
            syncTargets {
              emailAddress
              calendarId
            }
          }
        }
      }
    }
  `,
  org: graphql`
    fragment ChromePersonalCalendar_org on Org {
      id
      domains
    }
  `,
};
